export enum StatusCard {
  DONE = 'done',
  ASSIGNED = 'assigned',
  PENDING = 'pending',
  DONEMAYUS = 'Done',
  VIEWED = 'viewed'
}
